// Cette fonction permet d'extraire le sous-domaine de l'URL actuelle
export function getSubdomain() {
  // Récupère le nom d'hôte complet de l'URL (ex: "user1.get-to-know.me")
  const hostname = window.location.hostname;
  // Découpe le nom d'hôte en parties en utilisant le point comme séparateur
  const parts = hostname.split('.');

  // Gère le cas spécial du format "subdomain.localhost"
  // Par exemple: "user1.localhost" retournera "user1"
  if (parts.length === 2 && parts[1] === 'localhost') {
    return parts[0];
  }

  // Définit les patterns pour détecter les adresses IP
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/; // Ex: 192.168.1.1
  const ipv6Pattern = /^([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}$/; // Ex: 2001:0db8:85a3:0000:0000:8a2e:0370:7334

  // Retourne null si:
  // - l'hôte est une adresse IP (IPv4 ou IPv6)
  // - l'hôte est "localhost"
  // - l'hôte n'a pas assez de parties pour avoir un sous-domaine (ex: "example.com")
  if (
    ipv4Pattern.test(hostname) ||
    ipv6Pattern.test(hostname) ||
    hostname === 'localhost' ||
    parts.length <= 2
  ) {
    return null;
  }

  // Pour les sous-domaines normaux (ex: "user1.get-to-know.me")
  // Retourne toutes les parties sauf les 2 dernières, jointes par des points
  return parts.slice(0, parts.length - 2).join('.');
}
